// extracted by mini-css-extract-plugin
export default {"main":"CollapseHeader--main--Clu9t","leftSection":"CollapseHeader--leftSection--w8Fzn","title":"CollapseHeader--title--ughrE"};